module.exports = __webpack_public_path__ + "img/pic20.d0a15b0c.jpg";